import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    PDFViewer,
  } from '@react-pdf/renderer';
  import { useEffect, useState , useMemo } from 'react'
import axios from 'axios'
import URL from '../constants/ServerUrl'
import { htmlTemplate, htmlTemplateShort } from '../utils/billTemplate'

import { useSearchParams } from 'react-router-dom'
import { NepaliDatePicker } from 'nepali-datepicker-reactjs'
import { convertDateToAD, convertDateToBS } from '../utils/convertDate'

const GenerateBillPdf = ({ route }) => {
  const [farmerId, setFarmerId] = useState(null)
  const [farmerName, setFarmerName] = useState('')
  const [organizationName, setOrganizationName] = useState('')
  const [contactNumber1, setContactNumber1] = useState('')
  const [contactNumber2, setContactNumber2] = useState('')
  const [address, setAddress] = useState('')
  const [billTitle, setBillTitle] = useState('')
  const [panNumber, setPanNumber] = useState('')
  const [htmlData, setHtmlData] = useState('')
  const [searchParams] = useSearchParams();
  const username = searchParams.get('username');
  const [TOTALQty, setTotalQty] = useState(0)
  const [TOTALCredit, setTotalCredit] = useState(0)
  const [TOTALDebit, setTotalDebit] = useState(0)
  const [AVGFat, setAvgFat] = useState(0)
  const [AVGSnf, setAvgSnf] = useState(0)
  const [AVGRate, setAvgRate] = useState(0)
  const [PrevDues, setPrevDues] = useState(0)

  const [search, setSearch] = useState('')
  const [farmerData, setFarmerData] = useState([])
  const [focus, setFocus] = useState(false)

  const [startDate, setStartDate] = useState(convertDateToBS(Date.now() - 30 * 24 * 60 * 60 * 1000))
  const [endDate, setEndDate] = useState(convertDateToBS(Date.now()))
  const [isPickerShow1, setIsPickerShow1] = useState(false)
  const [isPickerShow2, setIsPickerShow2] = useState(false)
  const [startDateString, setStartDateString] = useState('')
  const [endDateString, setEndDateString] = useState('')
  const [tableData, setTableData] = useState([])
  const [ledgerData, setLedgerData] = useState([]);

  const [loading, setLoading] = useState(false)
  const [printLoading, setPrintLoading] = useState(false)
  const [farmerNotFound, setFarmerNotFound] = useState(false)
  const token = localStorage.getItem("dairy-token")


  let filteredTableData = tableData.filter((item) => item[0] == farmerId)

  useEffect(() => {
    if (username) {
      fetchAllFarmers()
      fetchBillDetails()
    }
  }, [])

  useEffect(() => {
    if (tableData.length > 0) {
      calculateOverall()
    }
  }, [filteredTableData])


  useEffect(() => {
    const nepalDate = String(startDate)
    setStartDateString(String(nepalDate))
  }, [startDate])

  useEffect(() => {
    const nepalDate = String(endDate)
    setEndDateString(nepalDate)
  }, [endDate])

  useEffect(() => {
    if (farmerId) {
      getRecord(farmerId)
    }
  }, [startDate, endDate])

  const fetchBillDetails = async () => {
    try {
      const bill = await axios.get(`${URL}user/${username}/bill`,{
        Authorization: `Bearer ${token}`,
      })
      setOrganizationName(bill.data.organizationName.toUpperCase())
      setContactNumber1(bill.data.contactNumber1)
      setContactNumber2(bill.data.contactNumber2)
      setAddress(bill.data.address)
      setPanNumber(bill.data.panNumber)
      setBillTitle(bill.data.billTitle)
      console.log(bill);
    } catch (error) {
      console.log(error)
    }
  }

  const fetchFarmerDetails = async (farmerId) => {
    try {
      if (username) {
        const farmer = await axios.get(`${URL}user/${username}/farmer/${farmerId}`,{
          Authorization: `Bearer ${token}`,
        })
        setFarmerName(farmer.data.farmerName)
        console.log(farmer);
      }
    } catch (error) {
      setFarmerNotFound(true)
      console.log(error)
    }
  }

  const fetchAllFarmers = async () => {
    try {
      const res = await axios.get(`${URL}user/${username}/farmer`,{
        Authorization: `Bearer ${token}`,
      })
      setFarmerData(res.data)
      console.log(res);
    } catch (err) {
      console.log(err)
    }
  }

  const fetchLedger = async () => {
    try {
      if (username) {
        let startAD=convertDateToAD(startDate);
        let endAD=convertDateToAD(endDate);
        const ledger = await axios.get(
          `${URL}user/${username}/ledger?startDate=${startAD}&endDate=${endAD}`,{
            Authorization: `Bearer ${token}`,
          }
        )
        const ledgerArray = ledger.data.map((ledger) => [
          ledger.farmerId,
          ledger.shift,
          ledger.fat,
          ledger.snf,
          convertDateToBS(new Date(ledger.date)),
          ledger.collection?.rate,
          ledger.qty,
          ledger.credit,
          ledger.debit,
          ledger.remarks,
        ])

        setTableData(ledgerArray)
        console.log(ledger);
      }
    } catch (error) {
      console.log(error)
    }
  }

  const showPicker1 = () => {
    setIsPickerShow1(true)
  }
  const showPicker2 = () => {
    setIsPickerShow2(true)
  }

  const onChangeStart = ( value) => {

    setStartDate(value)
  }

  const onChangeEnd = ( value) => {

    setEndDate(value)
  }

  

  const calculateOverall = async () => {
    console.log(filteredTableData)
    const totalQty = filteredTableData.reduce((acc, item) => {
      if (item[9] === 'Collection' && typeof item[6] === 'number') {
        return acc + item[6]
      }
      return acc
    }, 0)

    const totalCredit = filteredTableData.reduce((acc, item) => {
      if (item[9] === 'Collection' && typeof item[7] === 'number') {
        return acc + item[7]
      }
      return acc
    }, 0)

    const totalDebit = filteredTableData.reduce((acc, item) => {
      if (item[9] !== 'Collection' && typeof item[8] === 'number') {
        return acc + item[8]
      }
      return acc
    }, 0)

    const calculatedMilk = filteredTableData.reduce((acc, item) => {
      if (item[9] === 'Collection' && item[3] !== 0) {
        return acc + item[6]
      }
      return acc
    }, 0)

    const totalFat = filteredTableData.reduce((acc, item) => {
      if (item[9] === 'Collection' && item[3] !== 0) {
        return acc + item[3] * item[6]
      }
      return acc
    }, 0)

    const totalSnf = filteredTableData.reduce((acc, item) => {
      if (item[9] === 'Collection' && item[4] !== 0) {
        return acc + item[4] * item[6]
      }
      return acc
    }, 0)

    const totalRate = filteredTableData.reduce((acc, item) => {
      if (item[9] === 'Collection') {
        return acc + item[5] * item[6]
      }
      return acc
    }, 0)
    
    const avgFat = totalFat > 0 ? totalFat / calculatedMilk : 0
    const avgSnf = totalSnf > 0 ? totalSnf / calculatedMilk : 0
    const avgRate = totalRate > 0 ? totalRate / totalQty : 0

    // get previous balance
    const res = await axios.get(`${URL}user/${username}/dues/${farmerId}/prev?startDate=${startDate}&endDate=${endDate}`)
    const prevDues = res.data


    setTotalQty(totalQty.toFixed(2))
    setTotalCredit(totalCredit.toFixed(2))
    setTotalDebit(totalDebit.toFixed(2))
    setAvgFat(avgFat.toFixed(2))
    setAvgSnf(avgSnf.toFixed(2))
    setAvgRate(avgRate.toFixed(2))
    setPrevDues(prevDues.toFixed(2))

 
  }





 
  const getRecord = async (farmerId) => {
    try {
      setLoading(true)
      Promise.all([fetchFarmerDetails(farmerId), fetchLedger()]).catch((err) => {
        alert('Farmer not found')
      })
    } catch (error) {
      console.log(error)
      alert('Something went wrong')
    } finally {
      setLoading(false)
    }
  }


 

  return (
    <PDFViewer>
    <Document>
      <Page size="A4" >
    <div className="p-4">
    <input
      className="form-input mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
      placeholder='Enter Farmer Id or Name'
      type='text'
      onChange={(e) => {
        setSearch(e.target.value);
        if (e === '') {
          setFarmerId(null);
          setFocus(false);
          setHtmlData('');
        } else {
          setFocus(true);
        }
      }}
      value={search}
    />
    {focus && (
      <div className="mt-2">
        {search !== '' ? 
          farmerData
            .filter(({ farmerName, farmerId }) => {
              if (!isNaN(parseFloat(search))) return search == farmerId;
              return farmerName.toLowerCase().startsWith(search.toLowerCase());
            })
            .map((item) => (
              <div
                key={item.farmerId}
                onClick={() => {
                  setFarmerId(item.farmerId);
                  setSearch(item.farmerName);
                  setFocus(false);
                  getRecord(item.farmerId);
                }}
                className="cursor-pointer p-2 hover:bg-gray-100"
              >
                <div className="font-semibold">{item.farmerId}</div>
                <div className="text-gray-600">{item.farmerName}</div>
              </div>
            ))
          : null
        }
      </div>
    )}
  
    {!focus && (
      <>
        <div className="mt-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <div className="font-semibold">From</div>
              {!isPickerShow1 && (
                <button 
                  className="mt-1 text-sm text-blue-500 hover:text-blue-700" 
                  onClick={showPicker1}
                >
                  {startDateString}
                </button>
              )}
              {isPickerShow1 && (
                <NepaliDatePicker
                  inputClassName="form-control mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                  className="form-control border rounded-md p-2 focus:outline-none focus:border-blue-500"
                  value={startDate}
                  onChange={onChangeStart}
                  options={{ calenderLocale: 'en', valueLocale: 'en' }}
                />
              )}
            </div>
  
            <div>
              <div className="font-semibold">To</div>
              {!isPickerShow2 && (
                <button 
                  className="mt-1 text-sm text-blue-500 hover:text-blue-700" 
                  onClick={showPicker2}
                >
                  {endDateString}
                </button>
              )}
              {isPickerShow2 && (
                <NepaliDatePicker
                  inputClassName="form-control mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                  className="form-control border rounded-md p-2 focus:outline-none focus:border-blue-500"
                  value={endDate}
                  onChange={onChangeEnd}
                  options={{ calenderLocale: 'en', valueLocale: 'en' }}
                />
              )}
            </div>
          </div>
        </div>
  
        {!loading && !farmerId && (
          <div className="mt-4 text-gray-600">
            Search by name or id
          </div>
        )}
  
        {loading ? (
          <div className="mt-4 font-semibold">
            Loading Report...
          </div>
        ) : (
          <div className="mt-4 w-full">
            <h2 className="text-xl font-bold">{farmerName} (ID: {farmerId})</h2>
            <p className="text-gray-600">From {startDate} to {endDate}</p>
            <div className="overflow-x-auto">
            <table className="min-w-full">
        <thead>
          <tr>
            <th  className="px-5 py-5 border-b border-gray-200 bg-white text-sm">Date</th>
            <th  className="px-5 py-5 border-b border-gray-200 bg-white text-sm">Shift</th>
            <th  className="px-5 py-5 border-b border-gray-200 bg-white text-sm">Quantity</th>
            <th  className="px-5 py-5 border-b border-gray-200 bg-white text-sm">Fat</th>
            <th  className="px-5 py-5 border-b border-gray-200 bg-white text-sm">SNF</th>
            <th  className="px-5 py-5 border-b border-gray-200 bg-white text-sm">Rate</th>
            <th  className="px-5 py-5 border-b border-gray-200 bg-white text-sm">Credit</th>
            <th  className="px-5 py-5 border-b border-gray-200 bg-white text-sm">Debit</th>
            <th  className="px-5 py-5 border-b border-gray-200 bg-white text-sm">Remarks</th>
            
          </tr>
        </thead>
        <tbody>
          {filteredTableData.map((row, index) => (
            <tr key={index}>
              <td className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">{row[4]}</td>
              <td className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">{row[1]}</td>
              <td className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider" >{row[6]}</td>
              <td className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider" >{row[2]}</td>
              <td className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">{row[3]}</td>
              <td className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">{row[5]}</td>
              <td className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">{row[7]}</td>
              <td className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">{row[8]}</td>
              <td className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">{row[9]}</td>
          
          
   

            </tr>
          )
          )}
            <tr>
              <th>Total</th>
              <th> </th>
              <th>${TOTALQty}</th>
              <th>${AVGFat}</th>
              <th>${AVGSnf}</th>
              <th>${AVGRate}</th>
              <th>${TOTALCredit}</th>
              <th>${TOTALDebit}</th>
              <th></th>
            </tr>
        </tbody>
      </table>

      <table>
            <tr>
              <th>Total Amount</th>
              <td>Rs ${(TOTALCredit - TOTALDebit).toFixed(2)}</td>
            </tr>
            <tr>
            <th>Previous Balance (Purano Baki)</th>
            <td>Rs ${PrevDues}</td>
            </tr>
            <tr>
              <th>Net Balance</th>
              <td>Rs ${(TOTALCredit - TOTALDebit + Number(PrevDues)).toFixed(2)}</td>
            </tr>
        </table>
     

            </div>
          </div>
        )}
      </>
    )}
  </div>
  </Page>
      </Document>
    </PDFViewer>
  
  )
}


export default GenerateBillPdf
